<template>
	<!--
		Layout alinhado ao TR3_DataFinder Delphi:
		Classificação + Pesquisa, grade, rodapé X Sair | Todos | ✓ OK
	-->
	<Dialog :visible="datafinder.visible" :header="props.title" :show-header="true"
		style="width: 100vw; height: 100vh; min-width: 100vw; min-height: 100vh; max-height: 100vh; margin: 0;"
		content-class="p-0 r3-datafinder-content" :closable="false" modal :pt="{
			// mask: {
			// 	style: 'backdrop-filter: blur(2px)',
			// }
		}" @show="onDialogShow" @keydown="onDialogKeydown">
		<div class="r3-datafinder-body flex flex-column h-full min-h-0">
			<div v-if="props.showBackButton" class="flex-none px-2 pt-2">
				<Button
					icon="pi pi-arrow-left"
					severity="secondary"
					text
					aria-label="Voltar"
					:disabled="!buttonsEnabled"
					@click="onCloseDialog"
				/>
			</div>
			<div id="searchbar" class="r3-datafinder-field flex-none px-2 pt-2">
				<label class="r3-datafinder-label">Classificação</label>
				<R3DropDown :ref="datafinder.dropdown" v-model:model-value="searchfield" datafinder :enabled="inputsEnabled"
					:options="searchFields" option-value="campos" option-label="descrChave" class="w-full"
					append-to="body" />
			</div>
			<div id="searchtext" class="r3-datafinder-field flex-none px-2 pt-2">
				<label class="r3-datafinder-label">Pesquisa</label>
				<!-- Enter no texto: se só 1 resultado, confirma; se já há linha marcada, confirma ela -->
				<R3Input :ref="datafinder.text" v-model="searchValue" :disabled="!inputsEnabled"
					mode="search" autocomplete="off" name="r3-datafinder-search"
					@keydown:enter="onSearchEnter" />
			</div>

			<div v-if="loading && !hasSearchFields" class="flex-1 flex align-items-center justify-content-center">
				<Loading />
			</div>
			<div v-else id="resultado" class="flex-1 min-h-0 px-2 pt-2 r3-datafinder-resultado flex flex-column">
				<!--
					Seleção:
					- clique simples: marca a linha (já nativo do selection-mode)
					- duplo clique / Enter: confirma e fecha (mesmo que o botão ✓)
					VirtualScroller do PrimeVue 3 às vezes não emite row-dblclick —
					por isso também detectamos o 2º clique em @row-click.
					Rolagem horizontal: grade com min-width (Delphi DBGrid).
					Paginação (pageSize): contagem + setas no rodapé (não nas laterais).
				-->
				<div class="r3-datafinder-grid-wrap flex-1 min-h-0 flex flex-column">
					<div
						ref="gridScrollEl"
						class="r3-datafinder-grid-scroll flex-1 min-w-0 min-h-0"
						:class="{ 'r3-datafinder-grid-fit': fitColumns }"
					>
						<DataTable v-model:selection="datafinder.selectedRow.value" :selection-mode="props.selectionMode" scrollable
							:value="paginaAtual"
							class="p-datatable-sm h-full r3-datafinder-table"
							:class="{ 'r3-datafinder-table-fit': fitColumns }"
							:scroll-height="`calc(100vh - ${scrollheightSearchDataTable + 10}px)`"
							:table-style="tableMinWidthStyle"
							responsive-layout="scroll"
							:meta-key-selection="false"
							:virtual-scroller-options="virtualScrollerForPage"
							@row-unselect="onRowUnselect"
							@row-click="onRowClick"
							@row-dblclick="onRowDblClick"
						>
							<Column
								v-for="(item, colIdx) in props.columns"
								:key="item.field"
								:field="item.field"
								:header="item.header"
								:frozen="!fitColumns && colIdx === 0 && item.type === 'id'"
								:style="columnStyle(item)"
								:header-style="columnStyle(item)"
							>
								<template v-if="item.type === 'date'" #body="{ data }">
									{{ formatDataFinderDate((data as Record<string, unknown>)?.[item.field]) }}
								</template>
								<template v-else-if="item.type === 'id'" #body="{ data }">
									{{ formatDataFinderId((data as Record<string, unknown>)?.[item.field], item.padLength) }}
								</template>
								<template v-else #body="{ data }">
									<span class="r3-datafinder-cell" :title="String((data as Record<string, unknown>)?.[item.field] ?? '')">
										{{ (data as Record<string, unknown>)?.[item.field] ?? "" }}
									</span>
								</template>
							</Column>
						</DataTable>
					</div>
				</div>

				<!--
					Rodapé (Valter): uma seta pra descer (página) + outra pra lateral (colunas).
					▲▼ = sobe/desce páginas de mercadorias
					◀▶ = rola a grade na horizontal (Descrição / EAN / DUN / Emb.)
				-->
				<div
					v-if="showPagePager || showLateralArrows"
					class="r3-datafinder-pager flex-none flex flex-column align-items-center gap-2 py-2"
				>
					<div
						v-if="showPagePager"
						class="r3-datafinder-page-info text-center text-sm"
					>
						Página {{ currentPage }} de {{ totalPaginas }}
						<span class="text-color-secondary">
							· {{ totalRecords }} registro(s) · {{ allRows.length }} carregado(s)
						</span>
					</div>

					<div class="r3-datafinder-nav-row flex flex-row justify-content-center align-items-center gap-4 flex-wrap">
						<!-- Lista paginada: preserva a tela leve e traz a próxima parte sob demanda. -->
						<Button
							v-if="hasMore"
							class="r3-datafinder-btn"
							icon="pi pi-chevron-down"
							label="Carregar mais"
							severity="secondary"
							outlined
							:loading="loadingNextPage"
							:disabled="!buttonsEnabled || loadingNextPage"
							@click="loadNextPage"
						/>
						<!-- Lateral (colunas) -->
						<div
							v-if="showLateralArrows"
							class="r3-datafinder-nav-group flex flex-row align-items-center gap-2"
						>
							<button
								type="button"
								class="r3-datafinder-scroll-btn"
								aria-label="Rolar para a esquerda"
								@click="scrollGrid(-160)"
							>
								<span class="pi pi-arrow-left" />
							</button>
							<span class="r3-datafinder-nav-label">lateral</span>
							<button
								type="button"
								class="r3-datafinder-scroll-btn"
								aria-label="Rolar para a direita"
								@click="scrollGrid(160)"
							>
								<span class="pi pi-arrow-right" />
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Delphi: X Sair | Todos | ✓ OK -->
			<div id="toolbar" class="r3-datafinder-toolbar flex justify-content-between align-items-center flex-none gap-2 px-2 py-2">
				<Button
					v-if="shouldLoadAllOnOpen"
					class="r3-datafinder-btn"
					icon="pi pi-times"
					label="Sair"
					severity="danger"
					outlined
					:disabled="!buttonsEnabled"
					@click="onCloseDialog"
				/>
				<Button
					class="r3-datafinder-btn"
					icon="pi pi-list"
					label="Todos"
					severity="secondary"
					outlined
					:disabled="!buttonsEnabled"
					@click="searchAll"
				/>
				<Button
					class="r3-datafinder-btn"
					icon="pi pi-check"
					label="OK"
					severity="success"
					:disabled="!buttonsEnabled"
					@click="onConfirmButtonClick"
				/>
			</div>
		</div>
	</Dialog>
</template>

<script lang="ts" setup>
	import { useDebounce } from "@vueuse/core";
	import type { R3DataFinderParams, R3DataFinderProps } from "~/types/components/R3/datafinder.types";
	import { R3DataFinderClass } from "../../classes/base/R3DataFinder.classes";
	import { resolveInitialSearchField } from "./R3DataFinder/searchFieldResolver";

	const datafinder = new R3DataFinderClass();

	const props = withDefaults(defineProps<R3DataFinderProps>(), {
		orderBy: "ASC",
		searchAll: false,
		loadAllOnOpen: false,
		itemSize: 46,
		numToleratedItems: 50,
		selectionMode: "single",
		pageSize: 50,
		columnsLayout: "scroll",
	});

	/** Todas as colunas cabem na tela (B11 / print Delphi). */
	const fitColumns = computed(() => props.columnsLayout === "fit");

	/**
	 * AutomaticOpen (Delphi): carrega lista completa ao abrir / limpar pesquisa.
	 * Aceita `loadAllOnOpen` (preferido) ou `searchAll` (legado).
	 */
	const shouldLoadAllOnOpen = computed(
		() => Boolean(props.loadAllOnOpen || props.searchAll),
	);

	// Propaga o keyField da prop para a instância da classe para que os inputs
	// conectados via `dataFinderRef` possam acessá-lo sem dependência extra.
	datafinder.keyField = props.keyField;

	const { msgDlg } = useMessageDlg();

	const emits = defineEmits<{
		closeDialog: [payload: null];
		showDatafinder: [];
		onFailed: [error: unknown];
		dialogResult: [payload: Record<string, unknown>];
	}>();

	//const visible = ref(false);
	const visible = defineModel<boolean>("visible", { default: false });

	const scrollheightSearchDataTable = ref(0);

	/** Lista completa retornada pela busca. */
	const vTableData = ref<Array<object>>();

	const selectedRow = ref();

	const plugins = useNuxtApp();

	const searchfield = ref(props.keyField ?? "");

	const searchValue = ref("");

	const debouncedSearchValue = useDebounce(searchValue, 1000);

	/** Estado da paginação feita no banco. */
	const currentPage = ref(0);
	const totalPaginas = ref(0);
	const totalRecords = ref(0);
	const hasMore = ref(false);
	const hasSearched = ref(false);
	const loadingNextPage = ref(false);

	const gridScrollEl = ref<HTMLElement | null>(null);

	const showHScrollButtons = ref(false);

	const allRows = computed(() => (vTableData.value ?? []) as Array<object>);

	const pageSizeEffective = computed(() => {
		const n = Number(props.pageSize) || 50;
		return Math.min(50, Math.max(1, n));
	});

	const showPagePager = computed(() => hasSearched.value);

	/** As páginas recebidas são acumuladas; a grade não volta a fatiar no cliente. */
	const paginaAtual = computed(() => allRows.value);

	/** Com página fixa de N linhas, virtual scroller atrapalha a altura. */
	const virtualScrollerForPage = computed(() => {
		return { itemSize: props.itemSize, numToleratedItems: props.numToleratedItems };
	});

	function getGridScrollWrapper(): HTMLElement | null {
		const root = gridScrollEl.value;
		if (!root) return null;
		return (
			(root.querySelector(".p-virtualscroller") as HTMLElement | null) ||
			(root.querySelector(".p-datatable-wrapper") as HTMLElement | null) ||
			(root.querySelector(".p-datatable-table-container") as HTMLElement | null) ||
			(root.querySelector(".p-datatable-scrollable-body") as HTMLElement | null) ||
			root
		);
	}

	const infiniteScrollInstalled = new WeakSet<HTMLElement>();

	/** Carrega a próxima página quando a rolagem vertical chega perto do fim. */
	function installInfiniteScroll(wrapper: HTMLElement) {
		if (infiniteScrollInstalled.has(wrapper)) return;
		infiniteScrollInstalled.add(wrapper);
		wrapper.addEventListener("scroll", () => {
			const remaining = wrapper.scrollHeight - wrapper.scrollTop - wrapper.clientHeight;
			if (remaining <= props.itemSize * 3) void loadNextPage();
		}, { passive: true });
	}

	function scrollGrid(delta: number) {
		const wrapper = getGridScrollWrapper();
		if (!wrapper) return;
		wrapper.scrollBy({ left: delta, behavior: "smooth" });
		// reavalia após o scroll (setas de colunas)
		setTimeout(() => updateHScrollButtons(), 200);
	}

	/**
	 * Setas laterais: sempre com 3+ colunas (modo scroll) ou quando a grade
	 * realmente ultrapassa a largura. Em modo fit a grade cabe — lateral some.
	 */
	function updateHScrollButtons() {
		const wrapper = getGridScrollWrapper();
		if (wrapper) installInfiniteScroll(wrapper);
		if (fitColumns.value) {
			showHScrollButtons.value = false;
			return;
		}
		if (!wrapper) {
			// Assume lateral útil até medir (5 colunas DF_E468)
			showHScrollButtons.value = (props.columns?.length ?? 0) >= 3;
			return;
		}
		showHScrollButtons.value =
			wrapper.scrollWidth > wrapper.clientWidth + 2
			|| (props.columns?.length ?? 0) >= 4;
	}

	/** Alias semântico: seta lateral (◀ ▶) */
	const showLateralArrows = computed(() => showHScrollButtons.value);

	watch(() => allRows.value.length, () => nextTick(() => updateHScrollButtons()));

	type DataFinderRow = Record<string, unknown>;
	type DataFinderSearchResponse = {
		result: Array<DataFinderRow>;
		page: number;
		pageSize: number;
		totalRecords: number;
		totalPages: number;
		hasMore: boolean;
	};

	let activeSearchRequestId = 0;

	/**
	 * Ao trocar "Pesquisar por" (ex.: Descrição → Código), limpa o "Texto pesquisa".
	 * Evita reutilizar texto de descrição numa busca por código (e vice-versa).
	 * Ignora a atribuição inicial dos campos (oldField vazio) para não limpar em vão.
	 */
	watch(searchfield, (newField, oldField) => {
		if (!oldField || newField === oldField) {
			return;
		}

		if (searchValue.value !== "") {
			searchValue.value = "";
		}
	});

	watch(debouncedSearchValue, async () => {
		if (debouncedSearchValue.value !== "") {
			await search();
		}
		else if (shouldLoadAllOnOpen.value) {
			// Lista completa ao limpar o texto (AutomaticOpen)
			await searchAll();
		}
		else {
			vTableData.value = [];
			resetPagination();
		}
	});

	async function waitForSearchPaint() {
		await nextTick();
		await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
	}

	function getSearchResultRoute() {
		return "/api/genericdatafinder/getsearchresult" as const;
	}

	function getSearchFieldsRoute() {
		return "/api/genericdatafinder/getsearchfields" as const;
	}

	function applySearchFilter(rows: Array<DataFinderRow>, ignoreFilter = false) {
		if (props.filter && !ignoreFilter) {
			return props.filter(rows);
		}

		return rows;
	}

	/**
	 * Formata data do grid como DD/MM/YYYY.
	 * Prefere o trecho YYYY-MM-DD da string (ISO/Oracle) para não deslocar o dia por fuso.
	 */
	function formatDataFinderDate(value: unknown): string {
		if (value == null || value === "") {
			return "";
		}

		if (typeof value === "string") {
			const isoDate = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
			if (isoDate) {
				return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;
			}

			const brDate = value.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})/);
			if (brDate) {
				return brDate[0];
			}
		}

		const date = value instanceof Date ? value : new Date(String(value));
		if (Number.isNaN(date.getTime())) {
			return String(value);
		}

		return date.toLocaleDateString("pt-BR", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		});
	}

	/**
	 * ID/código com zeros à esquerda (Delphi StrZero), ex.: 013447.
	 */
	function formatDataFinderId(value: unknown, padLength = 6): string {
		if (value == null || value === "") {
			return "";
		}
		const digits = String(value).replace(/\D/g, "") || String(value);
		const len = Math.max(1, Number(padLength) || 6);
		return digits.padStart(len, "0");
	}

	/**
	 * Largura da grade.
	 * - fit: 100% da tela, todas as colunas visíveis (print Delphi B11)
	 * - scroll: min-width larga + rolagem horizontal
	 */
	const tableMinWidthStyle = computed(() => {
		if (fitColumns.value) {
			return { width: "100%", minWidth: "100%", tableLayout: "fixed" as const };
		}
		const cols = props.columns ?? [];
		if (cols.length === 0) return { minWidth: "28rem" };
		let minPx = 0;
		for (const col of cols) {
			if (col.width || col.minWidth) {
				const raw = col.width || col.minWidth || "8rem";
				const n = Number.parseFloat(String(raw));
				if (String(raw).includes("rem")) minPx += n * 16;
				else if (String(raw).includes("%")) minPx += 80;
				else if (String(raw).includes("px")) minPx += n;
				else minPx += 128;
			} else if (col.type === "id") {
				minPx += 5.5 * 16;
			} else if (col.type === "date") {
				minPx += 7 * 16;
			} else {
				minPx += 10 * 16;
			}
		}
		return { minWidth: `${Math.max(320, minPx)}px` };
	});

	/**
	 * Percentuais do DBGrid Delphi no coletor (fit):
	 * ID ~12% | Descrição ~36% | EAN13 ~20% | DUN14 ~20% | EMBALAGEM ~12%
	 */
	function columnStyle(item: {
		type?: string;
		field?: string;
		width?: string;
		minWidth?: string;
	}): Record<string, string> {
		const field = (item.field || "").toUpperCase();

		if (fitColumns.value) {
			let pct = "18%";
			if (item.type === "id" || field === "MERC_PF_468" || field === "MERC_PK_461") {
				pct = "12%";
			} else if (field === "DESCAPRES" || field.includes("DESCR")) {
				pct = "36%";
			} else if (field === "EAN13" || field === "DUN14") {
				pct = "18%";
			} else if (field === "EMBALAGEM") {
				pct = "12%";
			} else if (item.width?.includes("%")) {
				pct = item.width;
			}
			return {
				width: pct,
				maxWidth: pct,
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
			};
		}

		if (item.width || item.minWidth) {
			const style: Record<string, string> = { whiteSpace: "nowrap" };
			if (item.width) style.width = item.width;
			if (item.minWidth) style.minWidth = item.minWidth;
			else if (item.width) style.minWidth = item.width;
			return style;
		}
		if (item.type === "id") {
			return {
				width: "5.5rem",
				minWidth: "5.5rem",
				whiteSpace: "nowrap",
			};
		}
		if (item.type === "date") {
			return {
				width: "7rem",
				minWidth: "7rem",
				whiteSpace: "nowrap",
			};
		}
		if (field === "EAN13" || field === "DUN14") {
			return {
				width: "8.5rem",
				minWidth: "8.5rem",
				whiteSpace: "nowrap",
			};
		}
		if (field === "EMBALAGEM") {
			return {
				width: "5.5rem",
				minWidth: "5.5rem",
				whiteSpace: "nowrap",
			};
		}
		return {
			minWidth: "9rem",
			whiteSpace: "nowrap",
		};
	}

	/** Delphi: 1ª linha da grade marcada ao abrir (AutomaticOpen). */
	function selectFirstRowIfNeeded() {
		const rows = paginaAtual.value as Array<Record<string, unknown>>;
		if (!rows.length) {
			datafinder.selectedRow.value = null;
			return;
		}
		if (!datafinder.selectedRow.value) {
			datafinder.selectedRow.value = rows[0];
		}
	}

	function onRowUnselect(event: { data: unknown }) {
		// Em modo single, clicar na linha já selecionada desmarca (toggle).
		// Restauramos a seleção para evitar que o usuário fique sem seleção.
		// Em modo multiple, o toggle é comportamento esperado — não interferir.
		if (props.selectionMode !== 'single') return;

		nextTick(() => {
			if (datafinder.selectedRow.value == null) {
				datafinder.selectedRow.value = event.data as Record<string, unknown>;
			}
		});
	}

	/** Janela para considerar 2 cliques como "duplo clique" (ms). */
	const DBLCLICK_MS = 350;
	let lastRowClickAt = 0;
	let lastRowClickKey: string | number | null = null;

	function rowKey(row: Record<string, unknown> | null | undefined): string | number | null {
		if (!row) return null;
		const k = props.keyField ? row[props.keyField] : null;
		if (k !== null && k !== undefined) return k as string | number;
		// fallback estável o bastante para comparar cliques seguidos
		try {
			return JSON.stringify(row);
		} catch {
			return null;
		}
	}

	/**
	 * Clique simples marca a linha; segundo clique rápido na mesma linha confirma
	 * (equivalente ao botão ✓). Cobre o caso em que o VirtualScroller engole o
	 * `row-dblclick` nativo do PrimeVue.
	 */
	async function onRowClick(event: { data?: unknown }) {
		if (!buttonsEnabled.value) return;
		const row = (event?.data ?? null) as Record<string, unknown> | null;
		if (!row) return;

		const key = rowKey(row);
		const agora = Date.now();
		const mesmoRegistro = key !== null && key === lastRowClickKey;
		const dentroDaJanela = agora - lastRowClickAt <= DBLCLICK_MS;

		datafinder.selectedRow.value = row;

		if (mesmoRegistro && dentroDaJanela) {
			lastRowClickAt = 0;
			lastRowClickKey = null;
			await onConfirmButtonClick();
			return;
		}

		lastRowClickAt = agora;
		lastRowClickKey = key;
	}

	/**
	 * Duplo clique nativo na linha = seleciona e confirma (equivalente ao botão ✓).
	 * Mantido em paralelo ao detector de `row-click` (quando o evento chega).
	 */
	async function onRowDblClick(event: { data?: unknown }) {
		if (!buttonsEnabled.value) return;
		const row = (event?.data ?? datafinder.selectedRow.value) as Record<string, unknown> | null;
		if (!row) return;
		// evita confirmar 2x se o browser também disparar o 2º row-click
		lastRowClickAt = 0;
		lastRowClickKey = null;
		datafinder.selectedRow.value = row;
		await onConfirmButtonClick();
	}

	/**
	 * Enter com linha já marcada confirma.
	 * Não intercepta quando o foco está no campo de texto da pesquisa
	 * (lá o Enter é tratado em onSearchEnter).
	 */
	function onDialogKeydown(e: KeyboardEvent) {
		if (e.key !== "Enter" && e.key !== "NumpadEnter") return;
		if (!buttonsEnabled.value) return;

		const target = e.target as HTMLElement | null;
		const tag = target?.tagName?.toLowerCase();
		if (tag === "input" || tag === "textarea" || target?.isContentEditable) {
			return;
		}

		if (datafinder.selectedRow.value) {
			e.preventDefault();
			e.stopPropagation();
			void onConfirmButtonClick();
		}
	}

	/**
	 * Enter no "Texto pesquisa":
	 * - 1 resultado → seleciona e confirma
	 * - N resultados e já há seleção → confirma a seleção
	 * - senão só garante a busca (debounce/search já rodou ou roda agora)
	 */
	async function onSearchEnter() {
		if (!buttonsEnabled.value) return;

		if (!vTableData.value || vTableData.value.length === 0) {
			await search();
		}

		const rows = vTableData.value ?? [];
		if (rows.length === 1) {
			datafinder.selectedRow.value = rows[0] as Record<string, unknown>;
			await onConfirmButtonClick();
			return;
		}

		if (datafinder.selectedRow.value) {
			await onConfirmButtonClick();
		}
	}

	async function onConfirmButtonClick() {
		const row = datafinder.selectedRow.value as Record<string, unknown>;
		if (row == null) {
			// Sem linha marcada: não fecha o modal em branco
			return;
		}

		// 1. Sincroniza o valor-chave com os inputs conectados (watcher com flush:sync).
		//    Feito ANTES de chamar onDialogResult para que o callback do parent possa
		//    sobrescrever o valor exibido se necessário (ex.: mostrar nome em vez de ID).
		if (props.keyField && row[props.keyField] != null) {
			datafinder.confirmedKeyValue.value = row[props.keyField] as string | number;
		}

		// 2. Notifica o parent com a linha completa selecionada (suporte híbrido: callback e emit).
		if (props.onDialogResult) {
			await Promise.resolve(props.onDialogResult(row));
		}

		emits("dialogResult", row);

		// Limpa pesquisa/seleção para a próxima mercadoria (próxima abertura da lupa)
		searchValue.value = "";
		datafinder.selectedRow.value = null;
		resetPagination();

		close();
	}

	async function onCloseDialog() {
		emits("closeDialog", null);
		// vTableData.value = [];
		// emits("closeDialog");
		close();
	}

	// loading
	const loading = ref(false);
	const buttonsEnabled = ref(true);
	const inputsEnabled = ref(true);

	const hasSearchFields = ref(false);


	async function searchAll() {
		return search({
			searchField: "",
			searchValue: "",
			SQLOverride: props.SQLOverride,
			sync: true,
			page: 1,
		});
	}

	function resetPagination() {
		currentPage.value = 0;
		totalPaginas.value = 0;
		totalRecords.value = 0;
		hasMore.value = false;
		hasSearched.value = false;
	}

	async function loadNextPage() {
		if (!hasMore.value || loading.value || loadingNextPage.value) return;
		loadingNextPage.value = true;
		try {
			await search({ page: currentPage.value + 1, append: true });
		}
		finally {
			loadingNextPage.value = false;
		}
	}

	async function search(params?: {
		searchField?: string,
		searchValue?: string | number,
		params?: object[],
		SQLOverride?: string,
		sync?: boolean,
		ignoreFilter?: boolean,
		page?: number,
		append?: boolean,
	}) {
		const requestId = ++activeSearchRequestId;
		if (!params?.append) loading.value = true;

		await waitForSearchPaint();

		const sqlOverrideValue = params?.SQLOverride ?? props.SQLOverride;

		try {
			const response = await plugins.$r3fetchdata.get<DataFinderSearchResponse>(getSearchResultRoute(), {
				params: {
					DataFinderName: props.dataFinderName,
					Params: params?.params ? params.params : props.params,
					SearchValue: params?.searchValue ?? searchValue.value,
					SearchField: params?.searchField ?? searchfield.value,
					OrderField: params?.searchField ?? searchfield.value,
					OrderBy: props.orderBy,
					SQLOverride: sqlOverrideValue,
					Page: params?.page ?? 1,
					PageSize: pageSizeEffective.value,
				}
			});

			const resultado = applySearchFilter(response.result, params?.ignoreFilter);

			if (requestId === activeSearchRequestId) {
				vTableData.value = params?.append
					? [...(vTableData.value ?? []), ...resultado]
					: resultado;
				currentPage.value = response.page;
				totalPaginas.value = response.totalPages;
				totalRecords.value = response.totalRecords;
				hasMore.value = response.hasMore;
				hasSearched.value = true;
				// Marca a 1ª linha (como o DBGrid Delphi com foco na abertura)
				nextTick(() => {
					if (!params?.append) selectFirstRowIfNeeded();
					updateHScrollButtons();
				});
			}

			return resultado;
		} catch (error) {
			emits("onFailed", error);
			msgDlg("Erro", "atencao", "Erro ao realizar a busca.", ["OK"]);
			// datafinder.visible = false;
			throw error;
		} finally {
			if (requestId === activeSearchRequestId && !params?.append) {
				loading.value = false;
			}
		}
	}

	/**
	 * Realiza uma busca externa no DataFinder, podendo sobrescrever o sql padrão da busca nos parâmetros.
	 *
	 * Com `params` (lookup por campo/valor): retorna o **primeiro** registro por padrão.
	 *   - `loadAll=true` explícito devolve o array completo dos matches.
	 * Sem `params`: se `loadAll` (ou AutomaticOpen) for true, lista todos do SQL base.
	 *
	 * Importante: NÃO herdar `loadAllOnOpen` no lookup com valor — isso fazia
	 * `externalDataFinderSearch({ searchValue })` devolver um array e a tela
	 * tratar como linha (id/descrição/lastro undefined).
	 *
	 * @param params Parâmetros definidos para realização da busca
	 * @param loadAll Se true, retorna todos os registros (array)
	 * @returns O registro encontrado ou todos os registros, dependendo dos parâmetros
	 */
	async function externalDataFinderSearch<Response, ParamsT = unknown>(
		params: {
			searchField: string,
			searchValue: string | number,
			params?: R3DataFinderParams<ParamsT>,
			SQLOverride?: string,
			ignoreFilter?: boolean,
		} | undefined = undefined,
		loadAll?: boolean,
	): Promise<Response | null> {
		// Lookup pontual → 1 registro; lista completa só se pedir explicitamente ou AutomaticOpen sem params
		const wantAll = loadAll ?? (params ? false : shouldLoadAllOnOpen.value);

		if (params) {
			await search({
				searchField: params.searchField,
				searchValue: params.searchValue,
				params: params.params as object[],
				SQLOverride: params.SQLOverride,
				sync: true,
				ignoreFilter: params.ignoreFilter
			});

			if (vTableData.value && vTableData.value?.length > 0) {
				if (wantAll) {
					return vTableData.value as unknown as Response;
				}
				return vTableData.value[0] as unknown as Response;
			}
			else {
				return null;
			}
		}

		// Sem params + loadAll: carrega todos os registros do DataFinder (sem abrir o modal).
		// Usado por fluxos como carregarMotivosAvaria() para validar/listar opções.
		if (wantAll) {
			const resultado = await search({
				searchField: "",
				searchValue: "",
				SQLOverride: props.SQLOverride,
				sync: true,
			});
			if (resultado && resultado.length > 0) {
				return resultado as unknown as Response;
			}
			return null;
		}

		return null;
	}

	const searchFields = ref<Array<{
		nomeChave: string;
		descrChave: string;
		campos: string;
		ordem: ("asc" | "desc");
		default: boolean;
	}>>([]);

	async function getSearchFields() {
		loading.value = true;
		await plugins.$r3fetchdata.get<{
			result: Array<{
				nomeChave: string;
				descrChave: string;
				campos: string;
				ordem: ("asc" | "desc");
				default: boolean;
			}>;
		}>(getSearchFieldsRoute(), { params: { DataFinderName: props.dataFinderName } })
			.then(async (res: {
				result: Array<{
					nomeChave: string;
					descrChave: string;
					campos: string;
					ordem: ("asc" | "desc");
					default: boolean;
				}>;
			}) => {
				searchFields.value = res.result;
				hasSearchFields.value = true;
				searchfield.value = resolveInitialSearchField({
					currentSearchField: searchfield.value,
					keyField: props.keyField,
					searchFields: searchFields.value,
				});
				if (shouldLoadAllOnOpen.value) {
					await searchAll();
					// Lista vazia com AutomaticOpen: avisa (ex.: cadastro de motivo tipo 03 ausente)
					if (!vTableData.value || vTableData.value.length === 0) {
						await msgDlg(
							props.title || "Pesquisa",
							"informa",
							"Nenhum registro encontrado para listagem automática.",
							["OK"],
						);
					}
				} else {
					loading.value = false;
				}
			})
			.catch(() => {
				emits("onFailed", new Error("Falha ao carregar os campos de pesquisa do DataFinder"));
				// datafinder.visible = false;
				loading.value = false;
			});
	}

	function closeSearch() {

	}

	async function onDialogShow() {
		// Zera o valor confirmado para que re-selecionar a mesma linha em uma nova
		// abertura do modal ainda dispare o watcher reativo nos inputs conectados
		// (a mudança null → valor é necessária para o Vue detectar a diferença).
		datafinder.confirmedKeyValue.value = null;

		// Limpa texto de pesquisa e seleção da consulta anterior
		// (próxima mercadoria começa do zero, como no coletor Delphi).
		searchValue.value = "";
		datafinder.selectedRow.value = null;
		resetPagination();

		await nextTick();

		const toolbar = document.getElementById("toolbar");
		const searchbar = document.getElementById("searchbar");
		const searchtext = document.getElementById("searchtext");

		scrollheightSearchDataTable.value = (toolbar?.offsetHeight ?? 0) + (searchbar?.offsetHeight ?? 0) + (searchtext?.offsetHeight ?? 0);
		await getSearchFields();
		nextTick(() => {
			datafinder.text.value?.setFocus();
			updateHScrollButtons();
		});
	}



	function close() {
		datafinder.close();
	}

	function show() {
		datafinder.visible = true;
	}

	const expose = {
		show,
		close,
		externalDataFinderSearch,
		search,
		visible,
		searchfield,
		searchValue,
		keyField: props.keyField,
		onDialogResult: props.onDialogResult,
		// selectedRow
	}

	useExposeProperties(expose, datafinder);

	// Garantir que a implementação do componente sobrescreva o método abstrato da classe
	// (a classe base define um método que lança erro). Atribuímos aqui para garantir
	// que callers que usam a ref do componente chamem a implementação funcional.
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	//expose.externalDataFinderSearch = externalDataFinderSearch;

	defineExpose(expose);
</script>

<style scoped>
	/*
	 * Layout Delphi TR3_DataFinder:
	 * Classificação / Pesquisa no topo, grade no meio, Sair | Todos | OK embaixo.
	 */
	.r3-datafinder-body {
		min-height: 0;
		background: #f0f0f0;
	}

	.r3-datafinder-label {
		display: block;
		font-size: 0.85rem;
		font-weight: 600;
		margin-bottom: 0.25rem;
		color: #212121;
	}

	.r3-datafinder-toolbar {
		border-top: 1px solid #b5b5b5;
		background: #e8e8e8;
	}

	.r3-datafinder-btn {
		min-width: 5.5rem;
	}

	#resultado {
		min-height: 0;
		overflow: hidden;
	}

	.r3-datafinder-grid-scroll {
		overflow: hidden;
		min-height: 0;
		touch-action: pan-x pan-y;
	}

	/* Delphi DBGrid: rolagem horizontal + vertical (modo scroll) */
	.r3-datafinder-resultado :deep(.p-datatable-wrapper),
	.r3-datafinder-resultado :deep(.p-datatable-table-container),
	.r3-datafinder-resultado :deep(.p-datatable-scrollable-body),
	.r3-datafinder-resultado :deep(.p-datatable-scrollable-header-table),
	.r3-datafinder-resultado :deep(.p-datatable-scrollable-body-table) {
		overflow-x: auto !important;
	}

	.r3-datafinder-resultado :deep(.p-datatable-wrapper),
	.r3-datafinder-resultado :deep(.p-datatable-table-container) {
		overflow-y: auto !important;
		-webkit-overflow-scrolling: touch;
	}

	.r3-datafinder-resultado :deep(table) {
		width: max-content !important;
		min-width: 100%;
		table-layout: auto;
	}

	/* fit: 5 colunas Delphi sempre na tela (ID|Descrição|EAN13|DUN14|EMBALAGEM) */
	.r3-datafinder-grid-fit :deep(table),
	.r3-datafinder-table-fit :deep(table),
	.r3-datafinder-grid-fit :deep(.p-datatable-scrollable-header-table),
	.r3-datafinder-grid-fit :deep(.p-datatable-scrollable-body-table),
	.r3-datafinder-table-fit :deep(.p-datatable-scrollable-header-table),
	.r3-datafinder-table-fit :deep(.p-datatable-scrollable-body-table) {
		width: 100% !important;
		min-width: 100% !important;
		max-width: 100% !important;
		table-layout: fixed !important;
	}

	.r3-datafinder-grid-fit :deep(.p-datatable-wrapper),
	.r3-datafinder-grid-fit :deep(.p-datatable-table-container),
	.r3-datafinder-grid-fit :deep(.p-datatable-scrollable-body),
	.r3-datafinder-grid-fit :deep(.p-datatable-scrollable-header),
	.r3-datafinder-table-fit :deep(.p-datatable-wrapper),
	.r3-datafinder-table-fit :deep(.p-datatable-table-container),
	.r3-datafinder-table-fit :deep(.p-datatable-scrollable-body),
	.r3-datafinder-table-fit :deep(.p-datatable-scrollable-header) {
		overflow-x: hidden !important;
		width: 100% !important;
	}

	/* Larguras fixas por posição — 5 campos do Delphi DF_E468 */
	.r3-datafinder-grid-fit :deep(th:nth-child(1)),
	.r3-datafinder-grid-fit :deep(td:nth-child(1)),
	.r3-datafinder-table-fit :deep(th:nth-child(1)),
	.r3-datafinder-table-fit :deep(td:nth-child(1)) {
		width: 12% !important;
		max-width: 12% !important;
	}
	.r3-datafinder-grid-fit :deep(th:nth-child(2)),
	.r3-datafinder-grid-fit :deep(td:nth-child(2)),
	.r3-datafinder-table-fit :deep(th:nth-child(2)),
	.r3-datafinder-table-fit :deep(td:nth-child(2)) {
		width: 32% !important;
		max-width: 32% !important;
	}
	.r3-datafinder-grid-fit :deep(th:nth-child(3)),
	.r3-datafinder-grid-fit :deep(td:nth-child(3)),
	.r3-datafinder-table-fit :deep(th:nth-child(3)),
	.r3-datafinder-table-fit :deep(td:nth-child(3)) {
		width: 20% !important;
		max-width: 20% !important;
	}
	.r3-datafinder-grid-fit :deep(th:nth-child(4)),
	.r3-datafinder-grid-fit :deep(td:nth-child(4)),
	.r3-datafinder-table-fit :deep(th:nth-child(4)),
	.r3-datafinder-table-fit :deep(td:nth-child(4)) {
		width: 20% !important;
		max-width: 20% !important;
	}
	.r3-datafinder-grid-fit :deep(th:nth-child(5)),
	.r3-datafinder-grid-fit :deep(td:nth-child(5)),
	.r3-datafinder-table-fit :deep(th:nth-child(5)),
	.r3-datafinder-table-fit :deep(td:nth-child(5)) {
		width: 16% !important;
		max-width: 16% !important;
	}

	.r3-datafinder-resultado :deep(th),
	.r3-datafinder-resultado :deep(td) {
		white-space: nowrap;
		font-size: 0.68rem;
		padding: 0.3rem 0.2rem !important;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.r3-datafinder-cell {
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 100%;
	}

	.r3-datafinder-resultado :deep(.p-datatable-frozen-column) {
		background: #f8f9fa;
		font-weight: 600;
	}

	.r3-datafinder-scroll-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 2.25rem;
		min-height: 2.5rem;
		border: 1px solid #9e9e9e;
		border-radius: 3px;
		background: linear-gradient(to bottom, #fafafa 0%, #e8e8e8 100%);
		color: var(--primary-color, #2196f3);
		cursor: pointer;
		box-shadow: inset 0 1px 0 #fff;
	}

	.r3-datafinder-scroll-btn:disabled {
		opacity: 0.35;
		cursor: default;
	}

	.r3-datafinder-scroll-btn:not(:disabled):active {
		background: #e0e0e0;
	}

	.r3-datafinder-pager {
		border-top: 1px solid #dee2e6;
		background: #f8f9fa;
	}

	.r3-datafinder-page-info {
		font-weight: 600;
		color: #495057;
	}

	.r3-datafinder-nav-group .r3-datafinder-scroll-btn {
		width: 2.1rem;
		min-height: 2.1rem;
	}

	.r3-datafinder-nav-label {
		font-size: 0.75rem;
		font-weight: 700;
		color: #495057;
		min-width: 3.2rem;
		text-align: center;
		text-transform: lowercase;
	}

	.r3-datafinder-nav-row {
		width: 100%;
		padding: 0 0.5rem;
	}

	/*
	 * Linha selecionada.
	 *
	 * O tema do PrimeVue marca a seleção apenas com uma borda sutil, que num
	 * coletor — tela pequena, muitas vezes sob luz de galpão — quase não se
	 * distingue das demais linhas. Aqui a seleção recebe preenchimento sólido,
	 * texto em alto contraste e uma barra na lateral esquerda, de modo que
	 * fique legível de relance e não dependa só de cor.
	 */
	#resultado :deep(.p-datatable-tbody > tr.p-highlight) {
		background: #1789bf;
		color: #ffffff;
		box-shadow: inset 4px 0 0 0 #0d5f87;
	}

	#resultado :deep(.p-datatable-tbody > tr.p-highlight > td) {
		background: transparent;
		color: inherit;
		font-weight: 600;
		border-color: #1789bf;
	}

	/* Mantém a seleção visível quando o cursor passa por cima. */
	#resultado :deep(.p-datatable-tbody > tr.p-highlight:hover),
	#resultado :deep(.p-datatable-tbody > tr.p-highlight:focus) {
		background: #14799f;
		color: #ffffff;
	}

	/* Realce de foco por teclado, para navegação sem toque. */
	#resultado :deep(.p-datatable-tbody > tr:focus-visible) {
		outline: 2px solid #0d5f87;
		outline-offset: -2px;
	}

	@media (prefers-color-scheme: dark) {
		#resultado :deep(.p-datatable-tbody > tr.p-highlight) {
			background: #2a9fd4;
			box-shadow: inset 4px 0 0 0 #7fd3f5;
			color: #06232f;
		}

		#resultado :deep(.p-datatable-tbody > tr.p-highlight:hover) {
			background: #35abdf;
			color: #06232f;
		}
	}

	/* Rótulo ("Pesquisar por:" / "Texto pesquisa:") separado do respectivo campo. */
	#searchbar > :deep(*:not(:first-child)),
	#searchtext > :deep(*:not(:first-child)) {
		margin-top: 0.25rem;
	}
</style>
